import React, { Component } from 'react';
import Dayz from 'dayz';
import moment from 'moment';
import { Link } from 'react-router-dom';
import 'dayz/dayz.scss';
import { me } from '../../helpers/api/api';
import {
  Tabs,
  Tab,
  Table,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
} from 'carbon-components-react';
import { ChevronRight16, Close16 } from '@carbon/icons-react';
import Calendar20 from '@carbon/icons-react/lib/calendar/20';
import ArrowR20 from '@carbon/icons-react/lib/arrow--right/16';
import { api } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getError,
  entitiesLabels,
  apioperation,
  DateFormat,
} from '../../helpers/Constants';
import DateTimePicker from '../../helpers/DateTimePicker';
export default class CalendarTasks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabSelected: 0,
      tasks: [],
      mainTasks: [],
      overdueTasks: [],
      events: new Dayz.EventsCollection([]),
      currentDate: moment(new Date(moment().year(), moment().month(), moment().date())),
    };

    this.onDateChanged = this.onDateChanged.bind(this);
    this.onEventClick = this.onEventClick.bind(this);
    this.getTasks = this.getTasks.bind(this);
    this.formatEvents = this.formatEvents.bind(this);
    this.deleteTask = this.deleteTask.bind(this);

    this.getTasks(moment().month() + 1);
  }

  formatEvents(tasks) {
    var events = [];
    var flagApproval = false;
    var flagCompilation = false;
    for (var i = 0; i < tasks.length; i++) {
      var task = tasks[i];
      var ci;
      switch (task.category) {
        case 'Approval':
          if (flagApproval === true && tasks.slice(0,i).find(x=>x.assignedDate == task.assignedDate)) continue;
          flagApproval = true;
          ci = '1';
          break;
        case 'Compilation':
          if (flagCompilation === true && tasks.slice(0,i).find(x=>x.assignedDate == task.assignedDate)) continue;
          flagCompilation = true;
          ci = '2';
          break;
        default:
          ci = '3';
      }
      events.push({
        content: task.content,
        range: moment.range(moment(task.assignedDate).clone(), moment(task.assignedDate).clone()),
        colorIndex: ci,
      });
    }
    return new Dayz.EventsCollection(events);
    }



    deleteTask = async (id) => {
        this.setState((prevState) => ({
            isLoad: true,
            mainTasks: prevState.mainTasks.filter((x) => x.id !== id),
            overdueTasks: prevState.overdueTasks.filter((x) => x.id !== id)
        }));

        api.delete('/tasks/', id).then((response) => {
            this.setState(
                { isLoad: false }
            );
        });
    };


  getTasks(month) {
    var t = this;

    const data = {
      params: {
        page: 0,
        pageSize: 1000,
        month: month,
      },
    };

    me.getWithParam('tasks', data)
      .then((response) => {
        var tasks = response.data.itemList;
        var main = tasks.filter(
          (x) =>
            x.status !== 'Expired' &&
            moment(x.assignedDate).date() === moment(this.state.currentDate).date()
          );
          var overdue = tasks.filter((x) => x.status === 'Expired');
        this.setState({
          events: t.formatEvents(tasks),
          tasks: tasks,
          mainTasks: main,
          overdueTasks: overdue,
        });
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,getError(error, entitiesLabels.TASK, apioperation.GET));
      })
      .finally(() => {
        this.setState({
          isLoading: false,
          tabSelected: 0,
        });
      });
  }

  onDateChanged(inputName, inputValue, objName) {
    this.setState({
      currentDate: moment(inputValue),
    });
    this.getTasks(moment(inputValue).month() + 1);
  }

  onEventClick(ev, date) {
    var d = moment(date._d);

    if (d.month() !== this.state.currentDate.month()) {
      this.getTasks(d.month() + 1);
      this.setState({
        currentDate: moment(new Date(d.year(), d.month(), d.date())),
      });
    } else {
      var main = [];
      var overdue = [];
      for (var i = 0; i < this.state.tasks.length; i++) {
        if (moment(this.state.tasks[i].assignedDate).date() === d.date()) {
          if (this.state.tasks[i].status !== 'Expired') {
            main.push(this.state.tasks[i]);
          }
        }
        }
      this.setState({
        currentDate: moment(new Date(d.year(), d.month(), d.date())),
        mainTasks: main
      });
    }
  }
  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  render() {
    const row = this.state.tasks || [];

    function linkToEntity(id) {
      let entity = row.find((el) => el.id === id);

      if (entity != null && entity.reference != null) {
        return (
          <Link to={entity.reference}>
            <ChevronRight16 />
          </Link>
        );
      } else return '';
    }
    return (
      <div className="mainContainer">
        <div className="bx--grid calendar">
          <div className="bx--row">
            <div className="bx--col-max  bx--col-12 description-page box--title ">
              <h3>
                <Calendar20 className="color-calendar-icon" /> Daily Tasks
              </h3>
              <Link to={'/alltasks'}>
                <div className="link-ghost-action">
                  All Tasks
                  <div className="icon-ghost-action">
                    <ArrowR20></ArrowR20>{' '}
                  </div>
                </div>
              </Link>
            </div>

            <div className="indicator-month-calendar">
              <span className="month-indicator">
                {this.state.currentDate.format('MMMM')} {this.state.currentDate.year()}
              </span>
              {/*<DatePicker
                                datePickerType='single'
                                dateFormat="d/m/Y"
                                value={switchDateFormat(this.state.currentDate, `datepicker`)}
                                onChange={this.onDateChanged}
                                className="carbondatepicker-title dailyTaskCalendar iconDailyCalendar  iconCalendar-position"
                                light={true}
                            >
                                <DatePickerInput
                                    labelText=""
                                    onChange={this.onDateChanged}
                                    placeholder="dd/mm/yyyy"
                                    iconDescription="Icon description"
                                />
                            </DatePicker>*/}
              <DateTimePicker
                value={this.state.currentDate}
                type="date"
                placeholder={DateFormat}
                name="currentDate"
                alt="state"
                onChange={this.onDateChanged}
                disabled={this.state.isDisabled}
              />
            </div>

            <div className="bx--col-lg-2  bx--col-md-2  tex--title--calendar  title-text-calendar"></div>
            <div
              className="bx--col-lg-1  bx--col-md-2 custom--icon-calendar"
              onChange={this.onDateChanged}
            ></div>
          </div>
          <div className="bx--row">
            <div className="bx--col">
              <div className="days-header">
                <div className="days-label  header-calendar">Sun</div>
                <div className="days-label header-calendar">Mon</div>
                <div className="days-label header-calendar">Tue</div>
                <div className="days-label header-calendar">Wed</div>
                <div className="days-label header-calendar">Thu</div>
                <div className="days-label header-calendar">Fri</div>
                <div className="days-label header-calendar">Sat</div>
              </div>

              <Dayz
                display="month"
                date={this.state.currentDate}
                events={this.state.events}
                dayEventHandlers={{
                  onClick: this.onEventClick,
                }}
                onEventClick={this.onEventClick}
              />
            </div>
          </div>

          <div className="bx--row">
            <div className="bx--col  bx--tab-container paddingNone">
              <Tabs selected={this.state.tabSelected} tabContentClassName="tab-content">
                <Tab tabIndex={0} disabled={false} label={this.state.mainTasks.length + ' Main'}>
                  <div>
                    {this.state.mainTasks.length > 0 ? (
                      <TableContainer>
                        <Table>
                          <TableBody className="paddingNone">
                            {this.state.mainTasks.map((t) => (
                              <TableRow key={t.id}>
                                <TableCell key="action" className="paddingDataTable">
                                  <div className={t.category.toLowerCase()}>{t.category}</div>
                                </TableCell>
                                <TableCell key={'module-' + t.id}>{t.module}</TableCell>
                                <TableCell key={'content-' + t.id}>{t.content}</TableCell>
                                <TableCell key={'action-' + t.id} className="action-button-arrow">
                                  {linkToEntity(t.id)}
                                    </TableCell>
                                     <TableCell >
                                        <Close16
                                                onClick={() => this.deleteTask(t.id)}
                                                key={`delete-${t.id}`}
                                                size="small"
                                                iconDescription="Edit"
                                                kind="ghost"
                                            />
                                    </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <p className="notFound">No Main Tasks Found</p>
                    )}
                  </div>
                </Tab>

                <Tab
                  tabIndex={1}
                  disabled={false}
                  label={this.state.overdueTasks.length + ' Overdue'}
                >
                  <div>
                    {this.state.overdueTasks.length > 0 ? (
                      <TableContainer>
                        <Table>
                          <TableBody className="paddingNone">
                            {this.state.overdueTasks.map((t) => (
                              <TableRow key={t.id}>
                                <TableCell key="action" className="paddingDataTable">
                                  <div className={t.category.toLowerCase()}>{t.category}</div>
                                </TableCell>
                                <TableCell key={'module-' + t.id}>{t.module}</TableCell>
                                    <TableCell key={'content-' + t.id}>{t.content}</TableCell>
                                    <TableCell className="notification" key={'action-' + t.id}>{linkToEntity(t.id)}</TableCell>
                                    <TableCell className="notification dailyDelete" key={'content-' + t.id}>
                                    <a>
                                        <Close16
                                            onClick={() => this.deleteTask(t.id)}
                                            key={`delete-${t.id}`}
                                            size="small"
                                            iconDescription="Edit"
                                            kind="ghost"
                                            />
                                        </a>
                                    </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    ) : (
                      <p className="notFound">No Overdue Tasks Found</p>
                    )}
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
          <div></div>
        </div>
      </div>
    );
  }
}
